// components/templates/sections/VideoSection.tsx
'use client';
import { useDesign } from '@/context/DesignContext';

interface VideoSectionProps {
  videoUrl: string;
  design?: any;
}

export default function VideoSection({ videoUrl, design: propDesign }: VideoSectionProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const primaryColor = design?.colors?.primary || '#E07A5F';
  const boxShadow = design?.effects?.boxShadow || '0 5px 20px rgba(0,0,0,0.05)';
  const transition = design?.effects?.transition || 'all 0.3s ease';

  const playButtonStyle: React.CSSProperties = {
    backgroundColor: primaryColor,
    boxShadow: boxShadow,
    transition: transition,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    cursor: 'pointer',
  };

  return (
    <section className="s-video">
      <div className="container" style={{ maxWidth: design?.spacing?.containerMaxWidth || '1200px', margin: '0 auto' }}>
        <div className="row">
          <div className="col-12">
            <div className="video-main" style={{ textAlign: 'center', padding: '3rem 0' }}>
              <a href={videoUrl} className="popup-youtube wrap-video" style={playButtonStyle}>
                <i className="fa fa-play" style={{ fontSize: '2rem', color: '#fff' }}></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}